import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Company, User } from 'api/models';
import { AlertController, NavParams, Tabs, Tab, ModalController, Platform, ToastController, LoadingController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import { ProjectDetailTabsPage } from '../project-detail-tabs/project-detail-tabs';
import { ActivityListPage } from '../activities/activities';
import { LogsPage } from '../logs/logs';
import { Events } from 'ionic-angular/util/events';

import { Projects, Updates } from 'api/collections';
import { Project } from 'api/models';
// import { subscribeActiveCompany } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
// import { subscribeActiveProject, getActiveProjectId, getProject } from '../../services/projectData';
import { ProjectService } from '../../services/projectData';
import * as permissions from '../../services/permissions';
import { NewLogComponent } from '../new-log/new-log';
import { LogView } from '../log-view/log-view';
import { HelpModalComponent } from '../help-modal/help-modal';
import { SUPPORT_ONE, SUPPORT_TWO } from "../../services/config";
import { ISDEV, APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { App } from "ionic-angular";
import { AuthenticationService } from '../../services/congito';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'project-home',
  templateUrl: 'project-home.html'
})
export class ProjectHomePage implements OnInit {
  @ViewChild('projectHomeTabs') tabRef: Tabs;
  company: Company | void;
  project: Project | void;
  projectIdReactive: ReactiveVar < string > ;
  projectDetailsNavParams: Object;
  activityListNavParams: Object;
  projectLogsNavParams: Object;
  selectedTab: Tab;
  selectedTabView: ActivityListPage | ProjectDetailTabsPage | void;
  title: string;
  viewer: User;
  logId: string;
  update:any;
  canCreateLog: boolean = false;
  hasActivityListTab: boolean = false;
  hasPMDashboardTab: boolean = false;
  canAddGeneralLogs: boolean = false;
  activityListPage = ActivityListPage;
  pmDashboardPage = ProjectDetailTabsPage;
  projectLogsPage = LogsPage;
  notMobile= false;
  hideSelectedUpdateClick:any=null;
  terminate="terminate";
  complete="complete";
  public helpImage = SUPPORT_ONE;
  public isDev = ISDEV;

  constructor(
    private _app: App,
    private toastCtrl: ToastController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController,
    private events: Events,
    public platform: Platform,
    public httpService: HttpService,
    public companyService: CompanyService,
    public projectService: ProjectService,
    public authenticationService: AuthenticationService,
    private sharedService: SharedService,
    private router: Router,
    private route: ActivatedRoute
  ) 
  
  {
    if (this.platform.is('core') || this.platform.is('mobileweb')) {
      // This will only print when on iOS
      this.notMobile = true;
    }
  }

  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
    this.subscriptionLoop()
  }

  async subscriptionLoop(){
    this.viewer = this.authenticationService.MeteorUser();

    const navParamsProjectId = this.navParams.get('projectId');
    if(navParamsProjectId) {
      this.project = this.projectService.getProject(navParamsProjectId);
    } else {
      // utilize active project
      const activeProjectId = this.projectService.getActiveProjectId();
      if(!activeProjectId) {
        this.pickNewActiveProject();
        return;
      }

      this.project = this.projectService.subscribeActiveProject();
    }

    if(this.project) {
      if(this.projectIdReactive) {
        this.projectIdReactive.set(this.project._id);
      }
      if(this.viewer) {
        this.canCreateLog = this.project.pmIds.includes(this.viewer._id);
      }

      if(this.project && this.project._id){
        this.httpService.MeteorSubscribe('currentUpdateForProject', this.project._id)
        // .then(()=>this.httpService.privateLoopAction(true))
        .then(()=>this.update = Updates.findOne(this.project && this.project.currentUpdateId));
        
      }
    }
   if(this.isDev == true) {  console.log("this.viewerthis.viewer", this.viewer, this.project) }
    this.updatePermissionParams();
  }

  ngOnInit() {

    const navParamsProjectId = this.navParams.get('projectId');
    this.projectIdReactive = new ReactiveVar(navParamsProjectId);
    this.projectDetailsNavParams = {
      projectIdReactive: this.projectIdReactive,
    };
    this.activityListNavParams = {
      projectIdReactive: this.projectIdReactive,
    };
    this.projectLogsNavParams = {
      projectIdReactive: this.projectIdReactive,
    };
    if(this.isDev == true) {  console.log('project home page') }
    this.sharedService.httpUpdate.subscribe(
      async (res: any) => {
        this.subscriptionLoop();
      }
    )
    MeteorObservable.autorun().subscribe(() => {
      this.subscriptionLoop()
      if(!navParamsProjectId){
        this.pickNewActiveProject()
      }
    });
  }

  goToAddLog(): void {
    if(this.project) {
      const modal = this.modalCtrl.create(NewLogComponent, { projectId: this.project._id, logId: this.logId }, { enableBackdropDismiss: false });
      modal.present();
      this.router.navigate([this.project.name, 'logs', 'addNewDailyLog']);

      modal.onDidDismiss(() => {   
        if (this.project) {
          this.router.navigate([this.project.name, 'logs']);
        }
      });
    }
  }


  goToActivityHelpModal(): void {
    if(this.project) {
      const modal = this.modalCtrl.create(HelpModalComponent, {
        title: "Activity Help",
        helpImage: SUPPORT_ONE
      }, { enableBackdropDismiss: false });
      modal.present();
    }
  }

  goToLogHelpModal(): void {
    if(this.project) {
      const modal = this.modalCtrl.create(HelpModalComponent, {
        title: "Log Help",
        helpImage: SUPPORT_TWO
      }, { enableBackdropDismiss: false });
      modal.present();
    }
  }


  goToLogView(logId: string) {
    const modal = this.modalCtrl.create(LogView, {
      logId
    }, { enableBackdropDismiss: false });
    modal.present();
  }

  updatePermissionParams() {
    this.company = this.companyService.subscribeActiveCompany();
    const isCompanyAdmin = this.company ? permissions.isCompanyAdmin(this.company, this.viewer) : false;
    const isProjectManager = this.project ? permissions.isProjectManager(this.project, this.viewer) : false;

    this.hasActivityListTab = true;
    this.hasPMDashboardTab = isCompanyAdmin || isProjectManager;
    this.canAddGeneralLogs = isProjectManager;
  }

  onTabChange() {
    this.selectedTab = this.tabRef.getSelected();
    this.selectedTabView = this.selectedTab.root;
    this.title = this.selectedTab.tabTitle;

    if (this.project) { // this.project may not be instantiated by the time this code runs, in a cold start

      if (this.selectedTab.tabTitle == 'Activities') {

          // Extract the project name from the URL
          const firstString = decodeURI(this.router.url.split('/')[1]);
          
          if ( (firstString == this.project.name) || (firstString == 'login') ) { // We're staying with the same project, nothing changed
            
            if (this.update) {  // There is an update
              this.router.navigate([this.project.name, 'activities']);
            }
            else {
              this.router.navigate([this.project.name, 'noActiveUpdate']);
            }

          }
          else this.router.navigate([(this.router.url.split('/')[1]), 'activities']); // We're switching to a different project, so display that
      }
      if (this.selectedTab.tabTitle == 'Project Logs') {
          this.router.navigate([this.project.name, 'logs']);
      }
      if (this.selectedTab.tabTitle == 'Update Archive') {
          this.router.navigate([this.project.name, 'updateArchive']);
      }
    }
  }

  pickNewActiveProject() {
    if(!this.viewer) {
      return;
    }
    /*
    MeteorObservable.subscribe('projectsAcrossAllCompanies').subscribe(() => {
      const allProjects = Projects.find({ memberIds: this.viewer._id }).fetch();
      const newActiveProject = allProjects[0];
      if(!newActiveProject) {
        if(this.isDev == true) { console.warn('No projects found') }
        return;
      }
      MeteorObservable.call('setActiveProject', newActiveProject._id).subscribe({
        next: () => {
         if(this.isDev == true) {  console.log('Auto-selected active project') }
         console.log("proojjjjjjectis", newActiveProject)
        },
        error: (e: Error) => {
          this.handleError(e);
        }
      });
    });
    */

    this.httpService.MeteorSubscribe('projectsAcrossAllCompanies')
    .then(()=>this.httpService.privateLoopAction(true))
    .then(()=>{
      const allProjects = Projects.find({ memberIds: this.viewer._id }).fetch();
      let newActiveProject = allProjects[0];
      if(this.viewer && this.viewer.profile.activeProjectId){
        newActiveProject=Projects.findOne({ _id: this.viewer.profile.activeProjectId }) || newActiveProject;
      }
      if(!newActiveProject) {
        if(this.isDev == true) { console.warn('No projects found') }
        return;
      }
      this.httpService.MeteorCall('setActiveProject', newActiveProject._id)
        .then(() => {
          if(this.isDev == true) {  console.log('Auto-selected active project') }
        })
        .catch((e: Error) => {
          this.handleError(e);
        });
    })
    
  }

  handleError(err: Error): void {
  if(this.isDev == true) {   console.error('Error in appHome', err) }

    const alert = this.alertCtrl.create({
      buttons: ['OK'],
      message: err.message,
      title: 'Oops!'
    });

    alert.present();
  }
  selectUpdatePeriodFinishOption(value){
    if(value.includes("terminate")){
      this.terminate+="1";
      this.terminateUpdatePeriod()
    } else if(value.includes("complete")){
      this.complete+="1";
      this.completeUpdatePeriod()
    }
    this.hideSelectedUpdateClick=null;
    value=null;
    return null;
  }


  terminateUpdatePeriod(): void {

    const projectId = this.project && this.project._id;
    if(!projectId) {
      console.warn('Missing project');
      return;
    }

    const updateId = this.update && this.update._id;
    if(!updateId) {
      console.warn('Missing currentUpdate');
      return;
    }

    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      enableBackdropDismiss: true,
    });
    loader.present();
    this.httpService.MeteorCall('terminateUpdatePeriod', { projectId, updateId }).then(async (res)=>{
      await this.httpService.refreshSubscriptions()
      this.sharedService.updatePeriodGone.emit(updateId);
      loader.dismiss();
      this.showToast('Update period terminated successfully.');
    }).catch(err=>{
      loader.dismiss();
      this.showToast('Update period termination failed.');
    })
  }
  showToast(message: string) {
    let toast = this.toastCtrl.create({
      message,
      duration: 2500,
      position: 'top',
      dismissOnPageChange: true,
    });

    toast.present();
    return toast;
  }

  completeUpdatePeriod(): void {

    const projectId = this.project && this.project._id;
    if(!projectId) {
      console.warn('Missing project');
      return;
    }

    const updateId = this.update && this.update._id;
    if(!updateId) {
      console.warn('Missing currentUpdate');
      return;
    }
    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      enableBackdropDismiss: true,
    });
    loader.present();
    this.httpService.MeteorCall('completeUpdatePeriod', projectId, updateId)
    .then(async (res)=>{
      await this.httpService.refreshSubscriptions()
      this.sharedService.updatePeriodGone.emit(updateId)
      loader.dismiss();
      this.showToast('Update period completed successfully.');

    }).catch(err=>{
      loader.dismiss();
      this.showToast('Update period completion failed.');
    })


  }

}



// WEBPACK FOOTER //
// ./src/pages/project-home/project-home.ts